import { render, staticRenderFns } from "./indexer.vue?vue&type=template&id=c04bbdae"
import script from "./indexer.vue?vue&type=script&lang=js"
export * from "./indexer.vue?vue&type=script&lang=js"
import style0 from "./indexer.vue?vue&type=style&index=0&id=c04bbdae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports